/* ===================================================================
   THE FLOAT CLUB — shopify-config.js

   ▶▶ YOU ONLY NEED TO FILL IN TWO LINES: SHOP_DOMAIN and PRODUCT_HANDLE.

   Variant IDs are then resolved automatically at runtime from Shopify's
   public product endpoint (/products/<handle>.js), so there is no list
   of 30 IDs to paste and nothing to keep in sync when you add or rename
   a colourway. The manual VARIANTS map below stays as a fallback for
   the case where that endpoint is unavailable.

   WHERE TO GET THE TWO VALUES
   1) SHOP_DOMAIN  — Shopify admin > Settings > Domains > the entry under
      "Shopify-managed domain". Looks like  your-store.myshopify.com
      Keep the https:// prefix. No trailing slash.
   2) PRODUCT_HANDLE — open the product in admin, scroll to the bottom
      right, "Search engine listing" > Edit. The handle is the last part
      of the URL, e.g.  .../products/float-club-vest  ->  float-club-vest

   THE PRODUCT MUST BE SET UP AS:
     Option 1 = Colourway  (Signal Red, Sunrise Yellow, Lagoon Blue,
                            Deep Violet, Hibiscus Pink, Reef Print)
     Option 2 = Size       (XS, S, M, L, XL)
   The option VALUES must match those strings, because that is what the
   site matches on. Option ORDER does not matter.

   !! AND THE TWO AUTOMATIC DISCOUNTS !!
   Shopify admin > Discounts > Create > Amount off products > Automatic:
     - minus GBP 8.75  when quantity of this product is 2
     - minus GBP 20.99 when quantity of this product is 3 or more
   These are what make the site's promised totals the amount actually
   charged (GBP 61.23 for two, GBP 83.98 for three). Without them
   Shopify bills full price -- GBP 104.97 for what the site quoted as
   GBP 83.98, a GBP 20.99 overcharge on every three-vest order.
   TEST BEFORE GOING LIVE: put three in the cart, go through to Shopify
   checkout, confirm the total reads 83.98 and not 104.97.
=================================================================== */
(function (global) {
  "use strict";

  // ---- FILL THESE TWO IN -----------------------------------------
  var SHOP_DOMAIN    = "https://thefloatclub.store";   // e.g. "https://float-club.myshopify.com"
  var PRODUCT_HANDLE = "the-float-club-vest";   // e.g. "float-club-vest"
  // ----------------------------------------------------------------

  // Optional manual fallback. Only consulted if the live lookup fails.
  // Keys are "colour-size", slugified and lowercased.
  var VARIANTS = {};

  // filled by the live lookup
  var resolved = null;

  function slug(s) {
    return String(s).trim().toLowerCase().replace(/\s+/g, "-");
  }

  function hasDomain() {
    return !!SHOP_DOMAIN && SHOP_DOMAIN.indexOf("REPLACE_ME") === -1;
  }

  /* Pull the real variants straight from the store. Shopify serves
     /products/<handle>.js publicly with permissive CORS, so this needs
     no API key and no token. Any failure is swallowed and we fall back
     to the manual map -- a checkout that silently sends a wrong ID is
     far worse than one that declines to open. */
  function loadVariants() {
    if (!hasDomain() || !PRODUCT_HANDLE) return Promise.resolve(null);
    var url = SHOP_DOMAIN.replace(/\/$/, "") + "/products/" + PRODUCT_HANDLE + ".js";
    return fetch(url, { credentials: "omit" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return null;
        var map = {};
        p.variants.forEach(function (v) {
          // options come back in the store's own order; sort so that
          // whichever is the size lands second in our key
          var opts = (v.options || []).map(slug);
          var sizes = ["xs", "s", "m", "l", "xl"];
          var size = opts.filter(function (o) { return sizes.indexOf(o) !== -1; })[0];
          var colour = opts.filter(function (o) { return o !== size; }).join("-");
          if (colour && size) map[colour + "-" + size] = String(v.id);
        });
        resolved = Object.keys(map).length ? map : null;
        if (global.FC && global.FC.render) global.FC.render();
        return resolved;
      })
      .catch(function () { return null; });
  }

  function table() { return resolved || VARIANTS; }

  function getVariantId(colour, size) {
    if (!colour || !size) return null;
    return table()[slug(colour) + "-" + slug(size)] || null;
  }

  // Checkout may only open once we hold a real domain AND real IDs.
  function isConfigured() {
    if (!hasDomain()) return false;
    var t = table();
    for (var k in t) {
      if (String(t[k]).indexOf("REPLACE_ME") === -1) return true;
    }
    return false;
  }

  // items: [{ colour, size, qty }] -> Shopify cart permalink.
  // Any item without a known variant aborts the whole URL rather than
  // quietly dropping a line the customer thinks they are buying.
  function buildCheckoutUrl(items) {
    items = Array.isArray(items) ? items : [];
    var parts = [];
    for (var i = 0; i < items.length; i++) {
      var id = getVariantId(items[i].colour, items[i].size);
      if (!id) return null;
      var qty = (items[i].qty && items[i].qty > 0) ? Math.floor(items[i].qty) : 1;
      parts.push(id + ":" + qty);
    }
    if (!parts.length) return null;
    return SHOP_DOMAIN.replace(/\/$/, "") + "/cart/" + parts.join(",");
  }

  global.FC_SHOPIFY = {
    shopDomain: SHOP_DOMAIN,
    productHandle: PRODUCT_HANDLE,
    variants: VARIANTS,
    getVariantId: getVariantId,
    buildCheckoutUrl: buildCheckoutUrl,
    isConfigured: isConfigured,
    loadVariants: loadVariants
  };

  if (hasDomain() && PRODUCT_HANDLE) loadVariants();

})(window);
